<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>用户列表</b></p>
        </div>

        <el-table :data="userList" style="width: 100%" highlight-current-row>
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column prop="username" label="用户" min-width="30%">
            </el-table-column>
            <el-table-column prop="phone" label="注塑号" min-width="25%">
            </el-table-column>

            <el-table-column prop="createdTime" label="注册日期" min-width="25%">
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="20%">
            </el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        编辑
                    </el-button>
                </template>
</el-table-column> -->
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "userAdmin",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            userList: [],
            dialogFormVisible: false,

            form: {
                id: '',
                companyName: '大公司',
                username: '老板',
                phone: '18888888888',

                createdTime: new Date(),
                expireTime: '',
                status: 0
            },

            pageIndex: 0,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getAll() {

            const formData = new FormData()

            formData.append('id', this.userId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/user/all",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 400 || data.status == 401) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })

                    this.$router.push({ path: "/Login" })
                }

                this.userList = data.data
                this.total = this.userList[0].total

                for (let i in this.userList) {
                    this.userList[i].createdTime = this.$moment(this.userList[i].createdTime).format("YYYY-MM-DD")

                    if (this.userList[i].status == 0) {
                        this.userList[i].status = '禁用'
                    } else if (this.userList[i].status == 1) {
                        this.userList[i].status = '启用'
                    }
                }
            })
        },
        pageClick(currentPage) {
            // console.log('pageClick()')
            // console.log(currentPage)

            this.pageIndex = (currentPage - 1) * 10

            this.getAll()
        }
    },
    mounted() {

        this.getAll()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>